import clsx from 'clsx';
import React from 'react';
import Txt from 'components/atoms/Txt/Txt';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import classes from './Copyable.module.scss';
import type { CopyableProps } from './Copyable.types';

const Copyable: React.FC<CopyableProps> = ({
  clipboardValue,
  displayValue,
  className,
  onClick,
  title,
}) => {
  const displayText = displayValue ?? clipboardValue;
  const [text, setText] = React.useState(displayText);

  const { handleCopy } = useCopyToClipboard(clipboardValue, {
    onSuccess: () => {
      setText('Copied to clipboard!');
      setTimeout(() => {
        setText(displayText);
      }, 1500);
    },
  });

  function handleCopyClick() {
    handleCopy();
    onClick?.();
  }

  return (
    <button
      type="button"
      className={clsx(
        classes.root,
        className,
        title && classes.labelPlaceholder,
        title && classes.inputFilled,
      )}
      onClick={handleCopyClick}
    >
      <Txt component="span" className={classes.labelText}>
        {title}
      </Txt>
      <Txt className={classes.text} skipTranslation>
        {text}
      </Txt>
      <Txt className={classes.cta}>copy</Txt>
    </button>
  );
};

export default Copyable;
